var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconLockOpen = function SvgS2IconLockOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 6.4h-7V4.2c0-1.544 1.256-2.8 2.8-2.8.692 0 1.357.255 1.87.717a.6.6 0 1 0 .802-.892A3.992 3.992 0 0 0 8.001.2c-2.206 0-4 1.795-4 4v2.2h-.2c-.772 0-1.4.628-1.4 1.4v6c0 .772.628 1.4 1.4 1.4h8.4c.772 0 1.4-.628 1.4-1.4v-6c0-.772-.628-1.4-1.4-1.4Zm.2 7.4a.2.2 0 0 1-.2.2H3.8a.2.2 0 0 1-.2-.2v-6c0-.11.09-.2.2-.2h8.4c.11 0 .2.09.2.2v6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10a1 1 0 0 0-2 0c0 .322.163.596.4.779v.621a.6.6 0 0 0 1.2 0v-.621A.982.982 0 0 0 9 10Z"
  })));
};
export default SvgS2IconLockOpen;